import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';

@Component({
    selector: "icon-car-truck"
    ,templateUrl: "./icon.car.truck.component.html"
    ,styleUrls: ["./icon.car.truck.component.scss"]
})
export class IconCarTruckComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() bgColor:string = "fill-success";
    @Input() borderColor:string = "";
    @Input() imgWidth:string = "";
    @Input() imgHeight:string = "";

    constructor(){

    }

    ngOnInit() {
        let dW = 316;
        let dH = 191;
        if(!this.imgHeight) {
            let cW = parseInt(this.imgWidth);
            let tH = cW * dH / dW;
            this.imgHeight = "" + tH;
        }else{
            let cH = parseInt(this.imgHeight);
            let tW = cH * dW / dH;
            this.imgWidth = "" + tW;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }
}